import { Paper } from "@mui/material";
import { FormattedMessage } from "react-intl";

import { ConfirmationDialog } from "@dzambalaorg/mui-dialog-confirmation";
import { AddressLink } from "@dzambalaorg/mui-scanner";
import type { IContract } from "@framework/types";
import { Table } from "@dzambalaorg/ui-kit";

import { StyledTableCell, StyledTableCellDensed, StyledTableRow } from "./styled";

export interface IPaymentSplitterDialogViewProps {
  open: boolean;
  onCancel: () => void;
  onConfirm: () => void;
  viewItem: IContract | null;
}

export const PaymentSplitterDialogView = (props: IPaymentSplitterDialogViewProps) => {
  const { viewItem, onConfirm, open, ...rest } = props;

  if (!open || !viewItem) {
    return null;
  }

  const { address, parameters } = viewItem;

  const handleConfirm = (): void => {
    onConfirm();
  };

  return (
    <ConfirmationDialog open={open} message="dialogs.view" onConfirm={handleConfirm} {...rest}>
      <Table.Container component={Paper}>
        <Table aria-label="table">
          <Table.Body>
            <Table.Row>
              <StyledTableCell component="th" scope="row">
                <FormattedMessage id="form.labels.address" />
              </StyledTableCell>
              <Table.Cell>
                <AddressLink address={address} />
              </Table.Cell>
            </Table.Row>
            <Table.Row>
              <StyledTableCell component="th" scope="row">
                <FormattedMessage id="form.labels.parameters" />
              </StyledTableCell>
              <StyledTableCellDensed align="right">
                <Table>
                  <Table.Head>
                    <Table.Row>
                      <StyledTableCell>
                        <FormattedMessage id="form.labels.payee" />
                      </StyledTableCell>
                      <Table.Cell>
                        <FormattedMessage id="form.labels.shares" />
                      </Table.Cell>
                    </Table.Row>
                  </Table.Head>
                  <Table.Body>
                    {(parameters.payees as unknown as Array<string>).map((payee, i) => (
                      <StyledTableRow key={i}>
                        <StyledTableCell>
                          <AddressLink address={parameters.payees[i]} />
                        </StyledTableCell>
                        <Table.Cell>{parameters.shares[i]}</Table.Cell>
                      </StyledTableRow>
                    ))}
                  </Table.Body>
                </Table>
              </StyledTableCellDensed>
            </Table.Row>
          </Table.Body>
        </Table>
      </Table.Container>
    </ConfirmationDialog>
  );
};
